import type { ReactNode } from 'react'
import AdminNav from './AdminNav'

export default function AdminLayout({ children }: { children: ReactNode }) {
  return (
    <div data-testid="admin-layout" className="flex -m-4 lg:-m-6" style={{ minHeight: 'calc(100% + 3rem)' }}>
      {/* Caution stripe */}
      <div className="w-[27px] shrink-0 lg:rounded-l-lg overflow-hidden">
        <div
          className="h-full w-full"
          style={{
            background: 'repeating-linear-gradient(-45deg, #d4a017 0px, #d4a017 12px, #1c1917 12px, #1c1917 24px)',
          }}
        />
      </div>
      {/* Content */}
      <div className="min-w-0 flex-1 p-4 lg:p-6">
        <AdminNav />
        {children}
      </div>
    </div>
  )
}
